module.exports = __webpack_public_path__ + "static/gold-1ba7f0a1cd298d3a91c53af004e5b136.png";